<template>
  <form
    :action="action"
    method="post"
  >
    <slot />
    <input
      v-model="purchaseOrder.id"
      name="purchase_order_id"
      type="hidden"
    >
    <input
      v-model="user.authenticationToken"
      name="token"
      type="hidden"
    >
    <input
      v-model="user.email"
      name="email"
      type="hidden"
    >
    <input
      name="source"
      value="wux"
      type="hidden"
    >
    <input
      name="sc"
      class="sc-input"
      :value="sc"
      type="hidden"
    >
    <input
      name="partner_ref"
      class="partner-ref-input"
      :value="partnerRef"
      type="hidden"
    >
  </form>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      default: '',
    },
    partnerRef: {
      type: String,
      default: '',
    },
    purchaseOrder: {
      type: Object,
      default: {},
    },
    sc: {
      type: String,
      default: '',
    },
    user: {
      type: Object,
      default: {},
    },
  },
};
</script>
